export const ROLE_IDS = {
  ARAG: import.meta.env.VITE_ROLE_ARAG,
  ARAG_ADMIN: import.meta.env.VITE_ROLE_ARAG_ADMIN,
  MEMBER: import.meta.env.VITE_ROLE_MEMBER,
  POLICYHOLDER: import.meta.env.VITE_ROLE_POLICYHOLDER,
} as const

export type RoleName = keyof typeof ROLE_IDS

export type CustomerRoleNames = 'POLICYHOLDER' | 'MEMBER'

export type AragRoleNames = 'ARAG' | 'ARAG_ADMIN'
